/**
 * Implements `StorageUtils` using `localStorage`.
 */
export class LocalStorage {
    constructor() {
        this.get = (key) => {
            if (typeof window !== 'undefined') {
                return localStorage.getItem(key) || null;
            }
            return null;
        };
        this.set = (key, value) => {
            if (typeof window !== 'undefined') {
                localStorage.setItem(key, value);
            }
        };
        this.removeItem = (key) => {
            if (typeof window !== 'undefined') {
                localStorage.removeItem(key);
            }
        };
        this.clear = (prefix) => {
            if (typeof window !== 'undefined') {
                for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);
                    if (key && key.startsWith(prefix)) {
                        localStorage.removeItem(key);
                        i--;
                    }
                }
            }
        };
    }
}
